import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { map } from "rxjs";
import { EventsManagementService } from "../../../../../services/events-management.service";
import { LastEventsCardComponent } from "./last-events-card/last-events-card.component";

@Component({
    selector: "app-last-events-page",
    imports: [CommonModule, LastEventsCardComponent],
    templateUrl: "./last-events-page.component.html",
    styleUrl: "./last-events-page.component.scss"
})
export class LastEventsPageComponent {
  private readonly _eventService = inject(EventsManagementService);

  myEvents$ = this._eventService.getMyEvents(0, 4).pipe(map((res) => res.data));
}
